import { apiClient } from "helpers/api_helper";

export const getAllStateData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/StateProvince/GetAllStateProvince`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};


export const getStateByCountryId = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/StateProvince/GetStateProvinceSelectListByCountryId?countryId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};
